var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PLATFORM_ENDPOINTS, RequestMethods } from "../../constants";
import { trimEndSlash, getTokenRequestParameters } from "../../helpers";
import { getTokenFromResponseV2 } from ".";
export class PlatformRequestService {
    constructor(baseApiUrl, siteId, ajaxService, getTokenFromResponse, makeTokenRequest) {
        this.baseApiUrl = baseApiUrl;
        this.siteId = siteId;
        this.ajaxService = ajaxService;
        this.getTokenFromResponse = getTokenFromResponse;
        this.makeTokenRequest = makeTokenRequest;
    }
    getAnonymousToken() {
        const url = `${trimEndSlash(this.baseApiUrl)}/${trimEndSlash(PLATFORM_ENDPOINTS.ANONYMOUS)}/${this.siteId}`;
        const parameters = getTokenRequestParameters(url, this.getTokenFromResponse);
        return this.makeTokenRequest(this.ajaxService, parameters);
    }
    getLoginToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Standard login for platform is not yet fully migrated. RequestGateway.setToken is used for login right now.");
        });
    }
    getRenewedToken(token) {
        const url = `${trimEndSlash(this.baseApiUrl)}/${PLATFORM_ENDPOINTS.RENEW}`;
        const options = this.getRequestOptions(token, JSON.stringify({ token }));
        const parameters = getTokenRequestParameters(url, getTokenFromResponseV2, options);
        return this.makeTokenRequest(this.ajaxService, parameters);
    }
    logout(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${trimEndSlash(this.baseApiUrl)}/${trimEndSlash(PLATFORM_ENDPOINTS.LOGOUT)}`;
            const options = this.getRequestOptions(token, "");
            const parameters = getTokenRequestParameters(url, undefined, options);
            try {
                return yield this.makeTokenRequest(this.ajaxService, parameters);
            }
            catch (e) {
                console.warn(e);
            }
        });
    }
    getRequestOptions(token, body) {
        return {
            body,
            headers: {
                authorization: `Bearer ${token}`
            },
            method: RequestMethods.POST
        };
    }
    oneTimeTokenLogin(anonymousToken, oneTimeToken, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${trimEndSlash(this.baseApiUrl)}/${trimEndSlash(PLATFORM_ENDPOINTS.ONE_TIME_TOKEN)}`;
            const options = this.getRequestOptions(anonymousToken, JSON.stringify({ oneTimeToken, userId }));
            const parameters = getTokenRequestParameters(url, getTokenFromResponseV2, options);
            return yield this.makeTokenRequest(this.ajaxService, parameters);
        });
    }
}
//# sourceMappingURL=PlatformRequestService.js.map